import SwiperCore from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

export const swiperInit = () => {
  return SwiperCore.use([Pagination, Navigation, A11y]);
};
